import { supabase } from './supabaseClient';

/** Enviar mensaje en conexion aceptada */
export async function enviarMensaje(conexionId, contenido) {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) return { error: 'No autenticado' };

  const { data, error } = await supabase.from('mensajes').insert({
    conexion_id: conexionId,
    user_from_id: user.id,
    contenido: contenido.trim(),
  }).select().single();

  return { data, error };
}

/** Obtener mensajes de una conexion */
export async function obtenerMensajes(conexionId) {
  const { data, error } = await supabase
    .from('mensajes')
    .select('*')
    .eq('conexion_id', conexionId)
    .order('created_at', { ascending: true });
  return { data: data || [], error };
}

/** Marcar mensajes como leidos */
export async function marcarLeidos(conexionId, userId) {
  await supabase
    .from('mensajes')
    .update({ leido: true })
    .eq('conexion_id', conexionId)
    .neq('user_from_id', userId)
    .eq('leido', false);
}
